module.exports = __webpack_public_path__ + "static/img/new_instagram.60022ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/integration/new_instagram.png
// module id = Q5aw
// module chunks = 134